import { render, staticRenderFns } from "./ContractItem.view.vue?vue&type=template&id=66cf4f87&"
import script from "./ContractItem.view.vue?vue&type=script&lang=js&"
export * from "./ContractItem.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66cf4f87')) {
      api.createRecord('66cf4f87', component.options)
    } else {
      api.reload('66cf4f87', component.options)
    }
    module.hot.accept("./ContractItem.view.vue?vue&type=template&id=66cf4f87&", function () {
      api.rerender('66cf4f87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/contracts/partials/ContractItem.view.vue"
export default component.exports